import React, { useState, useRef, useEffect } from 'react';
import "./RiskContribution.scss";
import TagManager from "react-gtm-module";
import { BeatLoader } from 'react-spinners';
import { addZeroes } from "../../Utilities/AddZeros";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import RiskContributionGraph from '../RiskContributionGraph/RiskContributionGraph';
import { FetchRiskContribution } from "../../Apis/FetchRiskContribution";
import { handleApiError } from '../../actions/notificationActions';
import { useDispatch, useSelector } from 'react-redux';
import { toPng } from 'html-to-image';
import { updatePdfData } from '../../actions/pdfDataActions';
import TooltipComponent from '../TooltipComponent/TooltipComponent';

function RiskContribution({ portfolioId, isEmpty, isGeneratingPdf, activeTabLabel }) {
  // console.log("inside risk contri")
  var currObj = {
    style: "currency",
    currency: "USD",
  };

  const divRef = useRef(null);
  const dispatch = useDispatch();

  const [show, setShow] = useState(true);
  const [bdopen, setBdOpen] = React.useState(true);
  const [riskCOntributionTableData, setRiskCOntributionTableData] = React.useState([]);
  const [riskCOntributionGraphData, setRiskCOntributionGraphData] = React.useState([]);
  const [riskPortfolioKeyList, setRiskPortfolioKeyList] = React.useState([]);
  const [PortfolioMarketValue, setPortfolioMarketValue] = React.useState(0);
  const [PortfolioRisk, setPortfolioRisk] = React.useState(0);
  const [HistoricalRisk, setHistoricalRisk] = React.useState(0);
  const [IndexRisk, setIndexRisk] = React.useState();
  const [totalIndividualRiskContribution, setTotalIndividualRiskContribution] = React.useState(0);
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [selectedVixTicker, setSelectedVixTicker] = React.useState();
  const [maxNormalizedRisk, setMaxNormalizedRisk] = React.useState();
  const riskContributionData = useSelector(state => state.pdfData['Risk Contribution']);

  const captureAndDispatchData = async (dataFlag, data, riskcontributiondata,marketRisk,portfolioRisk, totalportfoliovalue, vix_data) => {
    if(dataFlag === 'Data Available'){
      if (divRef.current) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        const image = await toPng(document.getElementById('divToPrint'))
        const pdf_data = {
          activeTab: 'Risk Contribution',
          riskContriImgData: image,
          riskContributionTableData: riskcontributiondata,
          risk_contribution_headers: ["#", "SYMBOL", "POSITION NAME","STOCK VOLATILITY", "MARKET VALUE", "MARKET WEIGHT", "MARKET CONTRIBUTION","IDIOSYNCRATIC CONTRIBUTION", "TOTAL RISK CONTRIBUTION" ],
          totalPortfolioValue: totalportfoliovalue,
          marketRisk:marketRisk,
          portfolioRisk:portfolioRisk,
          totalPortfolioHoldings: riskcontributiondata.length
        };
        dispatch(updatePdfData('Risk Contribution', { pdf: pdf_data, allData: { risk_data: data, vix_data: vix_data }, portfolioid: portfolioId , dataFlag:dataFlag}));
      }
    }else {
      dispatch(updatePdfData('Risk Contribution', { dataFlag:dataFlag, portfolioid: portfolioId }));
    }
  };

  const setAPiData = (data, vix_all_data) => {
    if(data.status === 200){
      console.log("vix_all_data", vix_all_data);
      const vix_data = vix_all_data['vix']['6mo']['closeprice'];
      const vix_value = parseFloat(vix_data[vix_data.length - 1]).toFixed(2);
      let lyst = [];
      let i = 1;
      let maxNormalizedRisk = 0;
      setRiskPortfolioKeyList(Object.keys(data.result));
      for (let [key, value] of Object.entries(data.result["risk_contribution"])) {
        const normalizedRisk = (parseFloat(value.market_contribution) / data.result.portfolio_risk) * 100;
        maxNormalizedRisk = Math.max(maxNormalizedRisk, normalizedRisk);
        lyst.push({
          sr: i,
          symbol: key,
          position_name: value["Name"],
          market_value: value["Market Value"],
          stock_volatility: value["individual stock_volatility"],
          risk_contributions: parseFloat(value["risk_contributions"]),
          market_contribution: parseFloat(value["market_contribution"]),
          isolated_risk: parseFloat(value["isolated_risk"]),
          idiosyncratic_portion: parseFloat(value["idiosyncratic_portion"]),
          vix_value: vix_value,
          TradeDate: value["TradeDate"],
          normalizedRisk: (parseFloat(value["market_contribution"]) / data.result["portfolio_risk"]) * 100,
        });
        i++;
      }
      lyst.sort((a, b) => (b.risk_contributions+b.idiosyncratic_portion) - (a.risk_contributions + a.idiosyncratic_portion));
      setRiskCOntributionTableData([...lyst]);
      setRiskCOntributionGraphData([...lyst.slice(0, 10)]);
      setMaxNormalizedRisk(maxNormalizedRisk)
      setPortfolioMarketValue(data.result["portfolio_market_value"]);
      setPortfolioRisk(data.result["portfolio_risk"]);
      setHistoricalRisk(data.result["historical_market_risk"]);
      console.log("vix_value", vix_value)
      setIndexRisk(vix_value);
      setTotalIndividualRiskContribution(data.result['total_individual_risk_contribution']);
      setTimeout(() => {
        captureAndDispatchData('Data Available', data, lyst ,data.result["historical_market_risk"], data.result["portfolio_risk"],data.result["portfolio_market_value"],vix_all_data);
      }, 1000);
      const formattedVixTicker = `${data.result["vix_ticker"].slice(1)} [${data.result["selected_index"]} Volatility]`;
      setSelectedIndex(data.result["selected_index"]);
      setSelectedVixTicker(formattedVixTicker);
      TagManager.dataLayer({
        dataLayer: {
          event: 'Risk Contribution',
          userType: sessionStorage.getItem("selectedAcType"),
          user_id: sessionStorage.getItem("clientId")
        },
      });
    } else {
        setTimeout(() => {
          captureAndDispatchData('Data Not Available', data);
        }, 1000);
    }
  };

  const totalSums = riskCOntributionTableData.reduce((acc, curr) => {
    acc.marketValue += curr.market_value;
    acc.marketWeight += (curr.market_value / PortfolioMarketValue) * 100;
    acc.marketContribution += curr.market_contribution;
    acc.idiosyncraticContribution += curr.idiosyncratic_portion;
    acc.totalRiskContribution += curr.risk_contributions;
    acc.diversifiedRisk += curr.isolated_risk;
    return acc;
  }, { marketValue: 0, marketWeight: 0, marketContribution: 0, idiosyncraticContribution: 0, totalRiskContribution: 0, diversifiedRisk: 0 });

  useEffect(() => {
    if (portfolioId && !isEmpty && (activeTabLabel === 'Risk Contribution' || isGeneratingPdf)) {
      // Fetch and dispatch logic
      setBdOpen(true);
      if (riskContributionData && portfolioId === riskContributionData.portfolioid && riskContributionData.dataFlag === 'Data Available') {
        setAPiData(riskContributionData.allData.risk_data, riskContributionData.allData.vix_data)
        setBdOpen(false);
      } else {
        FetchRiskContribution(portfolioId).then((data) => {
          if (data.status === 200) {
            console.log("api ", data)
            setAPiData(data, data.result["graph_data"])
            setBdOpen(false);
          }
          else {
            handleApiError(data, dispatch);
            setAPiData(data);
            setBdOpen(false);
          }
        });
      }
    }
  }, []);

  return (
    <>
      {!isEmpty ? (
        <>
          {bdopen ? (
            <div className="loading-overlay">
              <BeatLoader color="#60034C" loading={bdopen} size={30} />
            </div>) : (
            <div className="drawercontent">
              <div id='divToPrint' className='GraphDiv' ref={divRef}>
                <div className="riskhead" id='graphHeader'>
                  <h2>Top 10 Risk Contributions</h2>
                  <div className="riskstate">
                    <h3 id="portfoliorisk">{PortfolioRisk.toFixed(2)}</h3>
                    <div className="lblrisk">Portfolio Volatility
                      <TooltipComponent id={'Portfolio Risk'} />
                    </div>
                  </div>
                  {/* <div className="riskstate">
                    <h3 id="portfoliorisk">{IndexRisk} %</h3>
                    <div className="lblrisk">{selectedVixTicker}
                      <TooltipComponent id={'Portfolio Risk'}/>
                    </div>
                  </div> */}
                  <div className="riskstate">
                    <h3 id="portfoliorisk">{HistoricalRisk.toFixed(2)}</h3>
                    <div className="lblrisk">Index Volatility
                      <>
                        &nbsp;<img src="Assets/risk-info.png" title= {`Historical ${selectedIndex} Volatility`}></img>
                      </>
                    </div>
                  </div>

                </div>
                {/* <div className='riskmodes'> */}
                {/* <div><span className='risk'></span>Risk Contribution<TooltipComponent id="Risk Contribution" data-tooltip-delay-hide="100000" /></div> */}
                {/* <div><span className='position'></span>Stock Volatility <TooltipComponent id="Stock Volatility" data-tooltip-delay-hide="100000"/></div> */}
                {/* <div><span className='vix'></span>{selectedVixTicker} </div> */}
                {/* </div> */}
                <div className="riskchart">
                  <p className='chartlbl left'>Annualized Volatility</p>
                  {riskCOntributionGraphData &&
                    <RiskContributionGraph
                      data={riskCOntributionGraphData}
                      maxNormalizedRisk={maxNormalizedRisk}
                      totals={{
                        marketContributionTotal: parseFloat(totalSums.marketContribution.toFixed(3)),
                        idiosyncraticPortionTotal: parseFloat(totalSums.idiosyncraticContribution.toFixed(4)),
                        isolatedRiskTotal: parseFloat(totalSums.diversifiedRisk.toFixed(3))
                      }}
                    />
                    // <RiskContributionGraph data={riskCOntributionGraphData} maxNormalizedRisk={maxNormalizedRisk} />P
                  }
                  <p className='chartlbl right'>Pct Of Portfolio Volatility</p>
                </div>
              </div>
              <div className='risk-contribution-table'>
                <div className="portfolio-table contributio-table">

                  <div id="portfolioriskdetails" className="table_holder table_head m0i">
                    <h3 onClick={() => setShow(!show)}>Portfolio Details {show && <span className="minus">-</span>} {!show && <span>+</span>}</h3>
                    {show &&
                      <TableContainer className="table_height">
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <TableCell size="small">#</TableCell>
                              <TableCell>Symbol</TableCell>
                              <TableCell>Position Name</TableCell>
                              <TableCell>Stock Volatility
                                {/* <TooltipComponent id={'Stock Volatility'} /> */}
                              </TableCell>
                              <TableCell>Market Value</TableCell>
                              <TableCell>Market Weight</TableCell>
                              <TableCell>Market Contribution</TableCell>
                              <TableCell>Idiosyncratic Contribution</TableCell>
                              <TableCell>Total Risk Contribution </TableCell>
                              <TableCell>Diversified Risk</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {riskCOntributionTableData.map((value) => (
                              <TableRow>
                                <TableCell>{value.sr}</TableCell>
                                <TableCell>{value.symbol}</TableCell>
                                <TableCell>{value.position_name}</TableCell>
                                <TableCell>{(value.stock_volatility).toFixed(2)}</TableCell>
                                <TableCell>
                                  {Number(
                                    addZeroes(Number(parseFloat(value.market_value).toFixed(2)))
                                  ).toLocaleString("en-US", currObj)}
                                </TableCell>
                                <TableCell>{((value.market_value / PortfolioMarketValue) * 100).toFixed(2)}%</TableCell>
                                <TableCell>{value.market_contribution}</TableCell>
                                <TableCell>{value.idiosyncratic_portion}</TableCell>
                                <TableCell>{value.risk_contributions}</TableCell>
                                <TableCell>{value.isolated_risk}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TableCell colSpan="3">Portfolio Total:</TableCell>
                              <TableCell></TableCell>
                              <TableCell>{Number(
                                addZeroes(Number(parseFloat(PortfolioMarketValue).toFixed(2)))
                              ).toLocaleString("en-US", currObj)}</TableCell>
                              <TableCell>100 %</TableCell>
                              <TableCell>{totalSums.marketContribution.toFixed(3)}</TableCell>
                              <TableCell>{totalSums.idiosyncraticContribution.toFixed(4)}</TableCell>
                              <TableCell>{Number(parseFloat(PortfolioRisk).toFixed(3))} </TableCell>
                              <TableCell>{totalSums.diversifiedRisk.toFixed(3)}</TableCell>
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    }
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="drawercontent">
          <p>Portfolio is Empty. Please add stock to proceed</p>
        </div>
      )}
    </>
  );
}

export default RiskContribution;
